module.exports = __webpack_public_path__ + "static/exec-leadership-openings-2a40426e06f82f6ea920a9bb7772e6a4.jpg";